














































































































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { Workspace, Summary } from "@/entities";
import * as _ from "lodash";
import { http } from "@/shared/https";

const namespace: string = "application";

@Component
export default class ProgressBarComponent extends Vue {
  @Action("rollbackWorkflow", { namespace }) rollbackWorkflow: any;
  @Action("showNotification", { namespace: "application" }) notify: any;

  @Prop() workFlowItems: any;
  rollbackOption: boolean = false;
  commentDialog: boolean = false;
  logId: number = 0;
  rollbackReason: string = "";
  showComments: boolean = false;

  showGreenBorder(item: any) {
    let show = false;
    _.forEach(this.workFlowItems.LogStatus, (obj) => {
      if (obj.StepId && obj.StepId == item.StepId) {
        show = true;
      }
    });
    return show;
  }

  currentStep(item: any) {
    let show = false;
    const step =
      this.workFlowItems.LogStatus[this.workFlowItems.LogStatus.length - 1];
    if (step && item.StepId == step.StepId) {
      show = true;
    }
    return show;
  }

  /**date conversion**/
  dateFormat(date) {
    return this.$services.format.formatUTC(date);
  }

  /** Get the revision log */
  get revisions() {
    if (this.workFlowItems.RevisionLog) return this.workFlowItems.RevisionLog;
    else return [];
  }

  /** transforming journey array based on current status */
  get mergedJourney() {
    let workflowInfo = this.workFlowItems;
    let arr: any;
    let completedSteps = this.workFlowItems.LogStatus.map((x) => x.StepId);
    let currentStep = this.workFlowItems.CurrentStep.WorkFlowStepId;
    let returnStatus = this.workFlowItems.CurrentStep.ReturnStatus;
    let returnDescription =
      this.workFlowItems.CurrentStep.ReturnStatusDescription;
    if (workflowInfo && workflowInfo.Journey) {
      const step =
        this.workFlowItems.LogStatus[this.workFlowItems.LogStatus.length - 1];
      // merge log status and journey to show audit info
      arr = workflowInfo.Journey.map(
        function (a: any) {
          //@ts-ignore
          return this[a.StepId] || a;
        },
        workflowInfo.LogStatus.reduce(function (r: any, a: any) {
          r[a.StepId] = a;
          return r;
        }, Object.create(null))
      );

      if (returnStatus) {
        var item = arr.find((x) => x.StepId === currentStep);
        item.Status = returnDescription;
      }

      if (step && step.ParentId) {
        var item = arr.find((x) => x.StepId === step.ParentId);
        if (!item.Status.includes(step.Status))
          item.Status = `${item.Status} (${step.Status})`;
        arr = arr.filter((item: any) => {
          return (
            item.IsForward != 0 &&
            (!item.ShowIfExists || completedSteps.includes(item.StepId))
          );
        });
      } else if (step && step.IsForward == 1) {
        arr = arr.filter((item: any) => {
          return (
            item.IsForward != 0 &&
            (!item.ShowIfExists || completedSteps.includes(item.StepId))
          );
        });
      } else if (step && step.IsForward == 0) {
        arr = this.workFlowItems.LogStatus.filter((x) => !x.ParentId);
      }
      workflowInfo.Journey = arr;
    }
    return workflowInfo.Journey;
  }

  /** show dialog */
  showDialog(id) {
    this.logId = id;
    this.rollbackReason = "";
    this.commentDialog = true;
  }

  /** close the dialog */
  close() {
    this.commentDialog = false;
    this.logId = 0;
    this.rollbackReason = "";
  }

  rollback() {
    let item: any = {};
    item.LogId = this.logId;
    item.Reason = this.rollbackReason;

    let message = this.$services.format.personalizeString(
      `${this.$t("isRequired")}`,
      ["Comment"]
    );
    if (!item.Reason) {
      this.notify({ text: message, isHtml: false, color: "error" });
    } else {
      this.rollbackWorkflow(item).then(res => {
        this.commentDialog = false;
        this.rollbackReason = "";
        this.$emit("rollback",item);
      });
    }
  }

  // showRollback() {
  //   this.rollbackOption = !this.rollbackOption;
  // }
}
